import React, {Component} from 'react'
import {Query} from 'react-apollo'
import DocumentTitle from 'react-document-title'
import assign from 'lodash/assign'
import get from 'lodash/get'

import {Loader} from '../containers/Loader'
import {BOARDS_PER_PAGE} from '../config'
import USERS_QUERY from '../graphql/UsersQuery.graphql'
import Users from './Users'
import {getPageTitle, getUser} from '../utils'
import cn from 'classnames'
import EmptyState from './EmptyState'
import CreateBoard from './Board/CreateBoard'


class UserSettings extends Component {
    state = {
        active: true,
        alertVisible: false
    }

    handleChangeActive = (e, active) => {
        e.preventDefault()
        this.setState({active})
    }

    handleAlertDismiss() {
        // console.log('test');
        // this.setState({ alertVisible: false });
    }

    render() {
        const {active} = this.state
        return (
            <DocumentTitle title={getPageTitle('UserSettings')}>
                <Query
                    query={USERS_QUERY}
                    // variables={{
                    //     first: BOARDS_PER_PAGE,
                    //     isArchived: active,
                    // }}
                >
                    {({loading, error, data, fetchMore, refetch}) => {
                        const users = get(data, 'getUsers', {})
                        const pageInfo = get(data, 'getUsers.pageInfo', {})

                            // if (error) return `Error! ${error.message}`;
                        // if (error) this.state.alertVisible = true;
                        return (
                            <div>

                                <div className="navbar bg-white border-bottom">
                                    <div className="btn-group" role="group" aria-label="Button group">
                                        <span className="text-muted">Settings</span>
                                        <span className="text-muted px-2">/</span>
                                        <span><a className="" href="/org-settings">Organization</a></span>
                                        <span><a className="px-3" href="/user-settings">Users</a></span>
                                    </div>
                                </div>

                            <div className="container">

                                {error ? (
                                    <div className="mt-3">
                                        <div className="alert alert-danger alert-dismissible fade show" role="alert">
                                            <strong>Sad Jellyfish 😫.</strong> We're are sorry, there was an error: ${error.message}, please try again.
                                            {/*<button type="button" className="close" data-dismiss="alert" aria-label="Close" onClick={this.handleAlertDismiss.bind(this)}>*/}
                                                {/*<span aria-hidden="true">&times;</span>*/}
                                            {/*</button>*/}
                                        </div>
                                    </div>
                                ) : null}

                                {loading ? null :

                                    <div className="w-100 mt-4">

                                    {/*<div className="row">*/}
                                        {/*<div className="col-1">*/}
                                            {/*<h4>Users</h4>*/}
                                        {/*</div>*/}
                                    {/*</div>*/}

                                    <div className="row">

                                        <Users
                                            edges={get(data, 'getUsers.edges', [])}
                                            pageInfo={pageInfo}
                                            onLoadMore={() =>
                                                fetchMore({
                                                    variables: {
                                                        after: pageInfo.endCursor,
                                                        first: BOARDS_PER_PAGE,
                                                    },
                                                    updateQuery: (prev, {fetchMoreResult}) => {
                                                        if (!fetchMoreResult) return prev
                                                        // Merge the edges together, but keep the new pageInfo
                                                        return assign({}, prev, {
                                                            getUsers: {
                                                                pageInfo: fetchMoreResult.getUsers.pageInfo,
                                                                edges: [...prev.getUsers.edges, ...fetchMoreResult.getUsers.edges],
                                                            },
                                                        })
                                                    },
                                                })
                                            }
                                        />
                                    </div>
                                </div>

                                }
                            </div>
                            </div>
                        )
                    }}
                </Query>
            </DocumentTitle>

        )
    }
}

export default UserSettings



// WEBPACK FOOTER //
// ./src/components/UserSettings.jsx